export default __webpack_public_path__ + "static/plan-for-success-0f614d8357107b644cf391e7aa5cbeef.jpg";